import React from "react";
import ContentBlock from "../ContentBlock";

function Placeholder() {
  const heading = "There are no exhibitions that match your query.";
  return (
    <ContentBlock heading={heading}>
      <p>Clear the filter to start a new query or browse all exhibitions.</p>
    </ContentBlock>
  );
}

Placeholder.displayName = "ExhibitionsLanding.Placeholder";

export default Placeholder;
